import { api, baseUrl } from "../../api";

export const getGroupConsignments = async (params?: any) => {
  const res = await api.get(`${baseUrl}/warehouse/group-consignment`, { params });
  return res.data;
};